export default __webpack_public_path__ + "static/media/gerente.f20936b0.png";